(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/actions/personal-result-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/actions/personal-result-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const _RTK2 = RTK,
  createAction = _RTK2.createAction;
const normalizePersonalResults = svs.components.marketplaceCompetition.services.helpers.normalizePersonalResults;
const _svs$components$marke = svs.components.marketplaceCompetition.services.selectors.personalResultSelectors,
  selectIndividualResults = _svs$components$marke.selectIndividualResults,
  selectTeamResults = _svs$components$marke.selectTeamResults;
const cacheTime = 10000;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const userSession = svs.core.userSession;
const fetchPersonalResultsActionCondition = _ref => {
  let competitionId = _ref.competitionId,
    teamIds = _ref.teamIds;
  if (!competitionId) {
    return false;
  }
  if (userSession.isAnonymous()) {
    return false;
  }
  if (!teamIds) {
    return false;
  }
};
const fetchPersonalResultsAction = createAsyncThunk('competition/fetchPersonalResults', async (_ref2, _ref3) => {
  let competitionId = _ref2.competitionId,
    teamIds = _ref2.teamIds,
    shouldFetchIndividualResults = _ref2.shouldFetchIndividualResults;
  let getState = _ref3.getState;
  const state = getState();
  const nowDate = Date.now();
  const results = [undefined, {}];
  if (shouldFetchIndividualResults) {
    const previousIndividualResults = selectIndividualResults(state, competitionId);
    results[0] = (previousIndividualResults === null || previousIndividualResults === void 0 ? void 0 : previousIndividualResults.data) || {};
    shouldFetchIndividualResults = !previousIndividualResults || new Date(previousIndividualResults.lastFetch).getTime() + cacheTime < nowDate;
  }
  const fetchTeamIds = [];
  teamIds.forEach(teamId => {
    const previousTeamResults = selectTeamResults(state, competitionId, teamId);
    results[1][teamId] = (previousTeamResults === null || previousTeamResults === void 0 ? void 0 : previousTeamResults.data) || {};
    if (!previousTeamResults || new Date(previousTeamResults.lastFetch).getTime() + cacheTime < nowDate) {
      fetchTeamIds.push(teamId);
    }
  });
  if (shouldFetchIndividualResults || fetchTeamIds.length > 0) {
    const response = await competitionHandler().fetchPlayerCompetitionResults(competitionId, fetchTeamIds, shouldFetchIndividualResults);
    const _normalizePersonalRes = normalizePersonalResults(response),
      _normalizePersonalRes2 = _slicedToArray(_normalizePersonalRes, 2),
      individualResult = _normalizePersonalRes2[0],
      teamsResult = _normalizePersonalRes2[1];
    if (individualResult) {
      results[0] = individualResult;
    }
    const teamResultIds = Object.keys(teamsResult);
    teamResultIds.forEach(result => {
      results[1][teamsResult[result].id] = teamsResult[result];
    });
  }
  return results;
}, {
  condition: fetchPersonalResultsActionCondition
});

const patchPersonalResultsAction = createAction('competition/patchPersonalResults');
setGlobal('svs.components.marketplaceCompetition.services.actions.personalResultActions', {
  fetchPersonalResultsAction,
  patchPersonalResultsAction
});

 })(window);